import { AllEnvironmentName, EnvironmentName, EnvironmentType, LocalEnvironmentName, StargateEnvironmentHost } from "../constants/environments.js";

export type ProdStargateHostsToEnvironmentNameMap = Readonly<{
    [StargateEnvironmentHost.PROD]: EnvironmentName.PROD;
}>;
export type ProdEnvironmentNameToStargateHostsMap = Readonly<{
    [EnvironmentName.PROD]: StargateEnvironmentHost.PROD;
}>;
export type StagingStargateHostsToEnvironmentNameMap = Readonly<Record<StargateEnvironmentHost, AllEnvironmentName>>;
export type StagingEnvironmentNameToStargateHostsMap = Readonly<Record<AllEnvironmentName, StargateEnvironmentHost>>;
export type GetStargateHostsToEnvironmentNameMapReturnType<Type extends EnvironmentType> = Type extends EnvironmentType.PROD
    ? ProdStargateHostsToEnvironmentNameMap
    : Type extends EnvironmentType.STAGING
      ? StagingStargateHostsToEnvironmentNameMap
      : never;
export type GetEnvironmentNameToStargateHostsReturnType<Type extends EnvironmentType> = Type extends EnvironmentType.PROD
    ? ProdEnvironmentNameToStargateHostsMap
    : Type extends EnvironmentType.STAGING
      ? StagingEnvironmentNameToStargateHostsMap
      : never;
const EnvironmentNameToStargateHostsMap: {
    [Type in EnvironmentType]: GetStargateHostsToEnvironmentNameMapReturnType<Type>;
} = {
    [EnvironmentType.PROD]: {
        [StargateEnvironmentHost.PROD]: EnvironmentName.PROD,
    },
    [EnvironmentType.STAGING]: {
        [StargateEnvironmentHost.PROD]: EnvironmentName.PROD,
        [StargateEnvironmentHost.ALPHA]: EnvironmentName.ALPHA,
        [StargateEnvironmentHost.BETA]: EnvironmentName.BETA,
        [StargateEnvironmentHost.CHI]: EnvironmentName.CHI,
        [StargateEnvironmentHost.DELTA]: EnvironmentName.DELTA,
        [StargateEnvironmentHost.EPSILON]: EnvironmentName.EPSILON,
        [StargateEnvironmentHost.FAKER]: EnvironmentName.FAKER,
        [StargateEnvironmentHost.GAMMA]: EnvironmentName.GAMMA,
        [StargateEnvironmentHost.IOTA]: EnvironmentName.IOTA,
        [StargateEnvironmentHost.KAPPA]: EnvironmentName.KAPPA,
        [StargateEnvironmentHost.LAMBDA]: EnvironmentName.LAMBDA,
        [StargateEnvironmentHost.LOCAL]: LocalEnvironmentName.LOCAL,
        [StargateEnvironmentHost.LOCAL2]: LocalEnvironmentName.LOCAL2,
        [StargateEnvironmentHost.MU]: EnvironmentName.MU,
        [StargateEnvironmentHost.NU]: EnvironmentName.NU,
        [StargateEnvironmentHost.OMEGA]: EnvironmentName.OMEGA,
        [StargateEnvironmentHost.OMICRON]: EnvironmentName.OMICRON,
        [StargateEnvironmentHost.PSI]: EnvironmentName.PSI,
        [StargateEnvironmentHost.STAGING]: EnvironmentName.PROD,
        [StargateEnvironmentHost.RHO]: EnvironmentName.RHO,
        [StargateEnvironmentHost.SIGMA]: EnvironmentName.SIGMA,
        [StargateEnvironmentHost.THETA]: EnvironmentName.THETA,
        [StargateEnvironmentHost.ZETA]: EnvironmentName.ZETA,
        [StargateEnvironmentHost.UMI]: EnvironmentName.UMI,
        [StargateEnvironmentHost.HADES]: EnvironmentName.HADES,
        [StargateEnvironmentHost.VOLDEMORT]: EnvironmentName.VOLDEMORT,
    },
};
const StargateHostsToEnvironmentNameMap: {
    [Type in EnvironmentType]: GetEnvironmentNameToStargateHostsReturnType<Type>;
} = {
    [EnvironmentType.PROD]: {
        [EnvironmentName.PROD]: StargateEnvironmentHost.PROD,
    },
    [EnvironmentType.STAGING]: {
        [EnvironmentName.PROD]: StargateEnvironmentHost.PROD,
        [EnvironmentName.ALPHA]: StargateEnvironmentHost.ALPHA,
        [EnvironmentName.BETA]: StargateEnvironmentHost.BETA,
        [EnvironmentName.CHI]: StargateEnvironmentHost.CHI,
        [EnvironmentName.DELTA]: StargateEnvironmentHost.DELTA,
        [EnvironmentName.EPSILON]: StargateEnvironmentHost.EPSILON,
        [EnvironmentName.FAKER]: StargateEnvironmentHost.FAKER,
        [EnvironmentName.GAMMA]: StargateEnvironmentHost.GAMMA,
        [EnvironmentName.IOTA]: StargateEnvironmentHost.IOTA,
        [EnvironmentName.KAPPA]: StargateEnvironmentHost.KAPPA,
        [EnvironmentName.LAMBDA]: StargateEnvironmentHost.LAMBDA,
        [LocalEnvironmentName.LOCAL]: StargateEnvironmentHost.LOCAL,
        [LocalEnvironmentName.LOCAL2]: StargateEnvironmentHost.LOCAL2,
        [EnvironmentName.MU]: StargateEnvironmentHost.MU,
        [EnvironmentName.NU]: StargateEnvironmentHost.NU,
        [EnvironmentName.OMEGA]: StargateEnvironmentHost.OMEGA,
        [EnvironmentName.OMICRON]: StargateEnvironmentHost.OMICRON,
        [EnvironmentName.PSI]: StargateEnvironmentHost.PSI,
        [EnvironmentName.RHO]: StargateEnvironmentHost.RHO,
        [EnvironmentName.SIGMA]: StargateEnvironmentHost.SIGMA,
        [EnvironmentName.THETA]: StargateEnvironmentHost.THETA,
        [EnvironmentName.ZETA]: StargateEnvironmentHost.ZETA,
        [EnvironmentName.UMI]: StargateEnvironmentHost.UMI,
        [EnvironmentName.HADES]: StargateEnvironmentHost.HADES,
        [EnvironmentName.VOLDEMORT]: StargateEnvironmentHost.VOLDEMORT,
    },
};
export const getStargateHostsToEnvironmentNameMap = <Type extends EnvironmentType>(params: {
    environmentType: Type;
}): GetStargateHostsToEnvironmentNameMapReturnType<Type> => {
    return EnvironmentNameToStargateHostsMap[params.environmentType];
};
export const getEnvironmentNameToStargateHostsMap = <Type extends EnvironmentType>(params: {
    environmentType: Type;
}): GetEnvironmentNameToStargateHostsReturnType<Type> => {
    return StargateHostsToEnvironmentNameMap[params.environmentType];
};
